module.exports = __webpack_public_path__ + "NHLprat_square-7bc86cae9a22d8f82593a45c82251c88.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/NHLprat_square.png
// module id = 1178
// module chunks = 1 2